// extracted by mini-css-extract-plugin
export var wrapperStyle = "sr_heading-module--wrapperStyle--Cq0IP";